import { ChainId } from '@pancakeswap/sdk'
import { Address } from 'viem'

import { SupportedChainId } from './supportedChains'

export type ContractAddresses<T extends ChainId = SupportedChainId> = {
  [chainId in T]: Address
}

export const ICAKE = {
  [ChainId.KASPLEX_TESTNET]: '0x',
  [ChainId.IGRA]: '0x',
  [ChainId.KASPLEX_MAINNET]: '0x',
} as const satisfies ContractAddresses<SupportedChainId>

export const CAKE_VAULT = {
  [ChainId.KASPLEX_TESTNET]: '0x',
  [ChainId.IGRA]: '0x',
  [ChainId.KASPLEX_MAINNET]: '0x',
} as const satisfies ContractAddresses<SupportedChainId>

export const CAKE_FLEXIBLE_SIDE_VAULT = {
  [ChainId.KASPLEX_TESTNET]: '0x',
  [ChainId.IGRA]: '0x',
  [ChainId.KASPLEX_MAINNET]: '0x',
} as const satisfies ContractAddresses<SupportedChainId>
